import axios from "axios";
import Vue from "vue";
import authHeader from "@/services/auth-header";
import config from "@/data/config";

const API_URL = config.baseURL;

export const pengguna = {
   namespaced: true,
   state: {
      data: [],
      menu: [],
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      getAll({ commit, rootState }) {
         rootState.isLoading = true;
         axios.get(`${API_URL}pengguna`, { headers: authHeader() }).then(
            (response) => {
               commit("SET_DATA", response.data);
               rootState.isLoading = false;
            },
            () => {
               rootState.isLoading = false;
            }
         );
      },

      insert({ commit, rootState }, data) {
         rootState.isLoading = true;
         return axios
            .post(`${API_URL}pengguna`, data, { headers: authHeader() })
            .then(
               (response) => {
                  commit("PUSH_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      update({ commit, rootState }, data) {
         rootState.isLoading = true;
         return axios
            .put(`${API_URL}pengguna/${data.id}`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("CHANGE_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      delete({ commit, rootState }, id) {
         rootState.isLoading = true;
         return axios
            .delete(`${API_URL}pengguna/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("REMOVE_ITEM", id);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      reset({ rootState }, id) {
         rootState.isLoading = true;
         return axios
            .put(
               `${API_URL}pengguna/reset/${id}`,
               {},
               { headers: authHeader() }
            )
            .then(
               (response) => {
                  rootState.isLoading = false;
                  Vue.$toast.success(JSON.stringify(response.data));
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      getMenu({ commit, rootState }, id) {
         rootState.isLoading = true;
         axios
            .get(`${API_URL}pengguna/get_menu/` + id, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_MENU", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      saveMenu({ rootState }, data) {
         rootState.isLoading = true;
         return axios
            .post(`${API_URL}pengguna/save_menu`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data;
      },
      SET_MENU(state, menu) {
         state.menu = menu;
      },
      PUSH_ITEM(state, item) {
         state.data.push(item);
      },
      CHANGE_ITEM(state, payload) {
         // var i = state.data.findIndex(data => data.id == item.id)
         // state.data.splice(i, 1)
         // state.data.push(item);

         // const item = state.data.find(item => item.id === payload.id);
         // Object.assign(item, payload);
         console.log(payload);
         const index = state.data.findIndex((item) => item.id === payload.id);
         if (index !== -1) {
            Vue.set(state.data, index, payload);
         }
      },
      REMOVE_ITEM(state, id) {
         var i = state.data.findIndex((data) => data.id == id);
         state.data.splice(i, 1);
      },
   },
};
